import './Login.css'
import * as React from 'react'
import { LoginState } from './LoginState'
import { Redirect } from 'react-router-dom'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/slide.css'
import Alert from 'react-s-alert'

class Login extends React.Component<any, LoginState>{
    private formRef: React.RefObject<HTMLFormElement>

    constructor(props: any) {
        super(props)

        const newState = new LoginState()
        newState.isValid = firebase.auth().currentUser !== null
        this.onEmailChange = this.onEmailChange.bind(this)
        this.onPasswordChange = this.onPasswordChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.formRef = React.createRef<HTMLFormElement>()

        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                firebase.firestore().collection('users').doc(user.uid).get().then(snapshot => {
                    if (snapshot.exists) {
                        const isConfirmed = snapshot.data()!.isConfirmed
                        this.setState({
                            isValid: isConfirmed,
                            updatePassword: !isConfirmed
                        })
                    }
                })
            }
        })
        this.state = newState
    }

    public render() {
        let page
        if (this.state.isValid) {
            page = <Redirect to="/" />
        } else if (this.state.updatePassword) {
            page = <Redirect to="/password" />
        } else {
            page = <div>
                <form className="Login" onSubmit={this.onSubmit} ref={this.formRef}>
                    <label htmlFor="email">Email:</label><br />
                    <input type="text" name="email" onChange={this.onEmailChange} required={true} value={this.state.email} /><br />
                    <label htmlFor="password">Password:</label><br />
                    <input type="password" name="password" onChange={this.onPasswordChange} required={true} value={this.state.password} /><br />
                    <input type="submit" />
                </form>
                <Alert stack={true} />
            </div>
        }
        return page
    }

    public onEmailChange(event: React.ChangeEvent<HTMLInputElement>) {
        Alert.closeAll()
        if (event.target.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null) {
            event.target.setCustomValidity('')
        } else {
            event.target.setCustomValidity('Invalid Email')
        }
        this.setState({ email: event.target.value })
    }

    public onPasswordChange(event: React.ChangeEvent<HTMLInputElement>) {
        Alert.closeAll()
        this.setState({ password: event.target.value })
    }

    private onSubmit(event: React.FormEvent) {
        Alert.closeAll()
        event.preventDefault()
        if (this.formRef.current!.checkValidity()) {
            firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
                .catch(err => {
                    Alert.error(err.message, {
                        effect: 'slide',
                        position: 'top',
                        timeout: 5000
                    })
                })
        }
    }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/login/Login.tsx